var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 200,
    viewBox: "0 0 220 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7014 27.1478C52.7014 39.9644 42.4385 50.2956 29.8507 50.2956C17.2628 50.2956 7 39.9644 7 27.1478C7 14.3312 17.2628 4 29.8507 4C42.4385 4 52.7014 14.3312 52.7014 27.1478Z",
    stroke: "#008CA5",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.608 27.1478C130.608 39.9481 140.921 50.2956 153.607 50.2956C166.293 50.2956 176.606 39.9481 176.606 27.1478C176.606 14.3475 166.293 4 153.607 4C140.921 4 130.608 14.3475 130.608 27.1478Z",
    stroke: "#008CA5",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.802 92.5173C114.802 105.318 104.489 115.665 91.8032 115.665C79.1171 115.665 68.8039 105.318 68.8039 92.5173C68.8039 79.717 79.1171 69.3695 91.8032 69.3695C104.489 69.3695 114.802 79.717 114.802 92.5173Z",
    stroke: "#008CA5",
    strokeWidth: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.8032,
    cy: 172.001,
    r: 22.9992,
    stroke: "#008CA5",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.087,
    cy: 172.001,
    r: 22.9992,
    stroke: "#008CA5",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7831 76.0744C75.4399 76.0744 76.7831 74.7313 76.7831 73.0744V46.0744C76.7831 44.4176 75.4399 43.0744 73.7831 43.0744C72.1262 43.0744 70.7831 44.4176 70.7831 46.0744V70.0744H46.7831C45.1262 70.0744 43.7831 71.4176 43.7831 73.0744C43.7831 74.7313 45.1262 76.0744 46.7831 76.0744H73.7831ZM44.9675 48.5015L71.6617 75.1957L75.9044 70.9531L49.2102 44.2589L44.9675 48.5015Z",
    fill: "#008CA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.82 76.0744C108.163 76.0744 106.82 74.7313 106.82 73.0744V46.0744C106.82 44.4176 108.163 43.0744 109.82 43.0744C111.477 43.0744 112.82 44.4176 112.82 46.0744V70.0744H136.82C138.477 70.0744 139.82 71.4176 139.82 73.0744C139.82 74.7313 138.477 76.0744 136.82 76.0744H109.82ZM138.636 48.5015L111.942 75.1957L107.699 70.9531L134.393 44.2589L138.636 48.5015Z",
    fill: "#008CA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8304 148.123C91.002 149.294 92.9015 149.294 94.073 148.123L113.165 129.031C114.336 127.859 114.336 125.96 113.165 124.788C111.993 123.617 110.094 123.617 108.922 124.788L91.9517 141.759L74.9812 124.788C73.8096 123.617 71.9101 123.617 70.7385 124.788C69.5669 125.96 69.5669 127.859 70.7385 129.031L89.8304 148.123ZM88.9517 118.665L88.9517 146.002L94.9517 146.002L94.9517 118.665L88.9517 118.665Z",
    fill: "#008CA5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.209 173.676C143.38 172.505 143.38 170.605 142.209 169.434L123.117 150.342C121.945 149.17 120.046 149.17 118.874 150.342C117.703 151.513 117.703 153.413 118.874 154.584L135.845 171.555L118.874 188.526C117.703 189.697 117.703 191.597 118.874 192.768C120.046 193.94 121.945 193.94 123.117 192.768L142.209 173.676ZM116.911 174.555L140.087 174.555L140.087 168.555L116.911 168.555L116.911 174.555Z",
    fill: "#008CA5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.384 173.676C218.555 172.505 218.555 170.605 217.384 169.434L198.292 150.342C197.12 149.17 195.221 149.17 194.049 150.342C192.878 151.513 192.878 153.413 194.049 154.584L211.02 171.555L194.049 188.526C192.878 189.697 192.878 191.597 194.049 192.768C195.221 193.94 197.12 193.94 198.292 192.768L217.384 173.676ZM192.086 174.555L215.262 174.555L215.262 168.555L192.086 168.555L192.086 174.555Z",
    fill: "#008CA5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55.4042,
    y1: 24.7421,
    x2: 127.608,
    y2: 24.7421,
    stroke: "#008CA5",
    strokeWidth: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo_colored.3eae29fd0d8fec93544903a7ca0d7794.svg";
export { ForwardRef as ReactComponent };